import React from "react";
import { Link } from "react-router-dom";
import "./styles/footer.css";

const Footer = () => (
	<div className="footer">
		<div className="footer-left">
			<span className="footer-name">Hamdan Israr</span>
			<span className="footer-tagline">Full-Stack & Mobile Developer · UAE</span>
		</div>
		<ul className="footer-nav">
			{[["/" , "Home"], ["/projects", "Projects"], ["/about", "About"], ["/contact", "Contact"]].map(([to, label]) => (
				<li key={to}><Link to={to}>{label}</Link></li>
			))}
		</ul>
		<div className="footer-copy">© {new Date().getFullYear()} Hamdan. All rights reserved.</div>
	</div>
);

export default Footer;
